import type {CSSProperties} from 'react';
import {font} from '../scale.js';
import {wedgePhoneFieldStyle} from './wedgePhoneField.js';

export type WedgeTerritoryFieldVariant = 'wedge-territory';

/* Released primary territory field of the Settings territory screen: a full-width native input on the surface fill with the card
   border, off-scale padding, a 13px radius and 15px type. It sets no outline of its own (the shipped Wedge sheet draws the focus
   ring) and no minimum height. It reads the exact legacy roles, so the shipped ink rules and the host theme variables keep
   matching. Share the plain phone field base, with only the territory radius and type overrides. */
const FIELD_RADIUS = 13;

export function wedgeTerritoryFieldStyle(): CSSProperties {
  return {
    ...wedgePhoneFieldStyle('wedge-phone'), borderRadius: FIELD_RADIUS, fontSize: font.callout,
  };
}
